module.exports = __webpack_public_path__ + "img/shanghai.72f9beb6.png";